<template>
  <div class="rightContent">
    <div class="right-con">
      <!--创建问卷-->
      <el-scrollbar style="height: 100%">
        <div class="questionnaire-new">
          <el-form ref="addAnswerTabs" :model="ruleForm" :rules="rules" class="addAnswerFrom">
            <el-form-item :label="$t('addOrEdit.类型')" class="paper-type" v-if="!edit">
              <el-radio v-model="ruleForm.paperType" label="0">{{
                $t('addOrEdit.标准问卷')
              }}</el-radio>
              <el-radio v-model="ruleForm.paperType" label="1">{{
                $t('addOrEdit.第三方问卷')
              }}</el-radio>
            </el-form-item>
            <el-form-item
              :label="$t('addOrEdit.问卷标题')"
              prop="title"
              :class="{ 'paper-title': ruleForm.paperType == '0' }"
            >
              <el-input
                type="text"
                :placeholder="$t('addOrEdit.请输入')"
                v-model.trim="ruleForm.title"
                show-word-limit
                class="inputLong"
                maxlength="150"
              ></el-input>
            </el-form-item>
            <el-form-item v-show="ruleForm.paperType == 0" :label="''" class="forceAnswer">
              <div class="item-content">
                <div class="item-content-item">
                  <el-switch v-model="forceAnswer" class="form-dark blueSwitch"></el-switch>
                  <el-tooltip class="item" effect="dark" placement="top" :visible-arrow="false">
                    <div slot="content">
                      {{ $t('addOrEdit.无法跳过答题') }}
                    </div>
                    <span class="tips-title">
                      {{ $t('addOrEdit.强制作答')
                      }}<img class="tip-icon" :src="require('@/svg/tip.svg')" />
                    </span>
                  </el-tooltip>
                </div>
                <div>
                  <el-switch v-model="agreementEnable" class="form-dark blueSwitch"></el-switch>
                  <el-tooltip class="item" effect="dark" placement="top" :visible-arrow="false">
                    <div slot="content">
                      {{ $t('addOrEdit.隐私协议提交问卷tips') }}
                    </div>
                    <span class="tips-title">
                      {{ $t('addOrEdit.隐私协议')
                      }}<img class="tip-icon" :src="require('@/svg/tip.svg')" />
                    </span>
                  </el-tooltip>
                </div>
              </div>
            </el-form-item>
            <div v-if="ruleForm.paperType == '0'">
              <div v-for="(answer, index) of answerList" :key="index" class="answers">
                <answerList
                  :number="index + 1"
                  :choose-options="answer.choose"
                  :serial="answer.options"
                  :force="answer.force"
                  :title="answer.title"
                  :scale-type.sync="answer.scaleType"
                  :id="answer.id"
                  :edit="edit"
                  @changeOptions="changeOptions"
                  @titleChage="titleChage"
                  @updateSerial="updateSerial"
                  @forceChange="forceChange"
                />
                <a
                  :title="$t('addOrEdit.删除')"
                  class="icon icon-clear"
                  v-if="isShowDelTitle"
                  @click="showContent(answer.id)"
                  ><i class="icon-del"></i>{{ $t('addOrEdit.删除题目') }}</a
                >
                <div
                  class="delContent"
                  v-if="showDelContent && showDelId === answer.id"
                  v-click-outside="hideContent"
                >
                  <p class="error-icon-content">
                    <i class="error-icon">i</i>{{ $t('addOrEdit.你确定要删除这题吗') }}
                  </p>
                  <div class="delContent-control">
                    <a href="javascript:;" @click="hideContent" class="delContent-cancel">{{
                      $t('addOrEdit.取消')
                    }}</a
                    ><a href="javascript:;" @click="removeList(index)" class="delContent-sure">{{
                      $t('addOrEdit.确定')
                    }}</a>
                  </div>
                </div>
              </div>
              <div v-show="answerList.length < 100" class="more-answer">
                <a
                  type="button"
                  class="addMoreanswer link-blue"
                  @click="addMoreanswer"
                  href="javascript:;"
                  >+ {{ $t('addOrEdit.添加新问题') }}</a
                >
              </div>
            </div>
            <div v-if="ruleForm.paperType == '1'">
              <el-form-item label="URL：" class="url-paper" prop="thirdPartyPaperUri">
                <el-input
                  type="url"
                  :placeholder="$t('addOrEdit.请输入以http://或https://开头的链接地址')"
                  v-model.trim="ruleForm.thirdPartyPaperUri"
                  class="inputLong"
                  maxlength="255"
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </el-scrollbar>
    </div>
    <div class="bottom-bar">
      <div class="questionnaire-control">
        <div class="new add-control">
          <div>
            <el-upload
              class="upload-demo"
              :action="uploadUrl"
              :on-success="uploadSuccess"
              :headers="headersObj"
              :on-error="uploadError"
              :file-list="fileList"
              :show-file-list="false"
              accept=".xlsx, .xls"
              v-if="ruleForm.paperType != 1"
            >
              <a class="link-blue" href="javascript:;">{{ $t('addOrEdit.导入问卷') }}</a>
            </el-upload>
            <a
              class="link-download"
              href="javascript:;"
              @click="downloadFunc"
              v-if="ruleForm.paperType != 1"
              ><i class="icon icon-import"></i>{{ $t('addOrEdit.下载问卷模板') }}</a
            >
            <el-button class="link-blue save-blue" :loading="saveLoading" @click="submeAnswer">{{
              $t('addOrEdit.保存问卷')
            }}</el-button>

            <a class="link-blue publish-blue" href="javascript:;" @click="submeAnswerThree">{{
              $t('addOrEdit.发布问卷')
            }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { getToken } from '@/utils/auth';
import answerList from '../questionnaire/answerList.vue';
import vClickOutside from 'v-click-outside';
import {
  addOrEditQusetionnaire,
  getPaperInfo,
  quickPublishing
} from '@/api/liveRequest/questionnaireApi';
export default {
  components: {
    answerList
  },
  inject: ['questionThis'],
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    actionTabsObj: {
      type: Object,
      default: null
    },
    showInfoState: {
      type: Boolean,
      default: false
    },
    editPaper: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    liveToken() {
      return this.$store.getters.liveToken;
    },
    liveId() {
      return this.$store.getters.liveId;
    },
    liveStartStatus() {
      return this.$store.getters.liveRoomStatus;
    }
  },
  data() {
    var checkThiedUri = (rule, value, callback) => {
      console.log(value, 'value');
      value = value.trim();
      if (!/(http|https):\/\/([\w.]+\/?)\S*/.test(value)) {
        callback(new Error(this.$t('addOrEdit.请输入以http://或https://开头的链接地址')));
      }
      callback();
    };
    return {
      showDelContent: false,
      addAnswerTitle: '',
      rules: {
        title: [{ required: true, message: this.$t('addOrEdit.请输入标题'), trigger: 'blur' }],
        thirdPartyPaperUri: [
          { required: true, message: this.$t('addOrEdit.请输入URL'), trigger: 'blur' },
          { validator: checkThiedUri, trigger: 'blur' }
        ]
      },
      options: [
        // 下拉框
        {
          value: 0,
          label: this.$t('addOrEdit.单选')
        },
        {
          value: 1,
          label: this.$t('addOrEdit.多选')
        },
        {
          value: 2,
          label: this.$t('addOrEdit.问答')
        }
      ],
      answerList: [
        {
          id: 1,
          value: 1,
          up: false,
          down: false,
          choose: 0,
          title: '',
          options: [
            {
              number: 'A',
              item: '',
              error: '',
              completion: false,
              required: false
            },
            {
              number: 'B',
              item: '',
              error: '',
              completion: false,
              required: false
            }
          ],
          scaleType: -1,
          force: false
        }
      ],
      loadingState: false,
      // 保存问卷时显示loading
      saveLoading: false,
      fileList: [],
      uploadUrl: `${config.cpp}handler/v2/paper/import`,
      isShowMove: null,
      headersObj: {
        token: getToken() || this.$store.getters.liveToken
      },
      isShowDelTitle: false,
      isShowMoveUp: false,
      isShowMoveDown: false,
      paperId: 0,
      ruleForm: {
        title: '',
        paperType: '0',
        thirdPartyPaperUri: ''
      },
      isNullOne: true,
      thirdPaper: false,
      visibleClear: false,
      showDelId: 0,
      forceAnswer: false, //强制作答
      agreementEnable: false, //隐私协议
      publishLoading: false,
      themeDark: true
    };
  },
  created() {
    this.changeTheme();
  },
  watch: {
    answerList: {
      immediate: true,
      handler(value) {
        console.log(value, 'answer');
        this.isShowDelTitle = value.length > 1 ? true : false;
        //this.visibleClear = this.isShowDelTitle;
      }
    },
    editPaper: {
      immediate: true,
      handler(value) {
        console.log(this.edit, '是否编辑');
        if (this.edit) {
          this.answerList = [];
          console.log(value, 'paperEdit7777');
          this.ruleForm.title = value.title;
          this.ruleForm.paperType = value.paperType + '';
          this.ruleForm.thirdPartyPaperUri = value.thirdPartyPaperUri;
          // this.scaleType = value.scaleType;
          this.paperId = value.id;
          value.questions.forEach((item) => {
            let question = {
              value: item.num,
              up: false,
              down: false,
              choose: item.type,
              title: item.title,
              options: item.options,
              scaleType: item.scaleType,
              id: item.num,
              force: item.force
            };
            this.answerList.push(question);
          });
          this.$nextTick(() => {
            this.forceAnswer = value.forceAnswer;
            this.agreementEnable = value.agreementEnable;
          });
        } else {
          this.ruleForm.title = '';
          this.ruleForm.thirdPartyPaperUri = '';
          this.paperId = '';
          this.answerList = [
            {
              id: 1,
              value: 1,
              up: false,
              down: false,
              choose: 0,
              title: '',
              options: [
                {
                  number: 'A',
                  item: '',
                  error: '',
                  completion: false,
                  required: false
                },
                {
                  number: 'B',
                  item: '',
                  error: '',
                  completion: false,
                  required: false
                }
              ],
              scaleType: -1,
              force: false
            }
          ];
        }
      }
    }
  },
  methods: {
    changeTheme() {
      const theme = document.querySelector('html').getAttribute('data-theme') ?? 'blue';
      console.log(theme, 'changeTheme');
      if (theme.toLocaleLowerCase() == 'blue') {
        this.themeDark = true;
      } else {
        this.themeDark = false;
      }
    },
    showContent(id) {
      console.log(id, '显示删除弹框');
      this.showDelContent = true;
      this.showDelId = id;
    },
    hideContent() {
      this.showDelContent = false;
      this.showDelId = 0;
    },
    validatePass() {},
    /**下载模板 */
    downloadFunc() {
      console.log('downloadFunc');
      axios({
        url: `${config.cpp}handler/v2/paper/download/template`,
        responseType: 'arraybuffer',
        method: 'get'
      })
        .then((res) => {
          console.log(res, 'downloadFunc');
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', this.$t('addOrEdit.问卷模板') + '.xlsx');
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(this.$t('addOrEdit.文件下载失败'));
        });
    },
    /**文件上传成功 */
    uploadSuccess(res) {
      if (res.code === 200) {
        let _data = res.data;
        let _questions = _data.questions;
        this.ruleForm.title = _data.title;
        this.forceAnswer = _data.forceAnswer; //导入问卷成功添加是否强制作答状态
        this.agreementEnable = _data.agreementEnable; //导入问卷成功添加是否隐私协议状态

        let tempArray = [];
        _questions.forEach((val) => {
          let options = val.options;
          if (val.type === 5 && val.scaleOptionSize > 0) {
            for (let i = 0; i < val.scaleOptionSize; i++) {
              let op = {
                item: i + 1,
                completion: false,
                score: i + 1,
                required: false,
                number: String.fromCharCode(i + 65),
                showInput: false
              };
              if (i === 0) {
                op.item = this.$t('addOrEdit.很不满意');
              }
              if (i === val.scaleOptionSize - 1) {
                op.item = this.$t('addOrEdit.很满意');
              }
              options.push(op);
            }
          }
          tempArray.push({
            title: val.title,
            choose: val.type,
            options: options,
            scaleType: val.type === 5 ? 0 : -1,
            force: val.force
          });
        });
        // this.answerList = tempArray;
        this.answerList = tempArray.map((info, index) => {
          return Object.assign(info, { value: index + 1, id: index + 1 });
        });
        console.log(this.answerList, 'answerList....');
        this.$message.success(this.$t('addOrEdit.导入成功'));
      } else {
        // 交互设计为统一提示内容
        this.$message.error(
          this.$t('addOrEdit.导入的数据错误，导入失败，请检查导入内容的格式是否正确')
        );
      }
    },

    /**导入失败 */
    uploadError() {
      this.$message.error(this.$t('addOrEdit.导入失败'));
    },
    hovers(index) {
      this.isShowMove = index;
    },
    removeHove() {
      this.isShowMove = null;
    },
    /** 获取问卷详情 */
    getPaperInfoFunc() {
      this.loadingState = true;
      getPaperInfo(
        {
          id: this.actionTabsObj.id
        },
        this.$store.getters.liveToken
      )
        .then((res) => {
          if (res.code === 200) {
            let _data = res.data;
            this.addAnswerTitle = _data.title;
            this.dataList = _data.questions;
            let _answerList = [];
            _data.questions.forEach((val) => {
              _answerList.push({
                title: val.title,
                options: val.options,
                choose: val.type,
                force: val.force
              });
            });
            this.answerList.push(_answerList);
          }
          this.loadingState = false;
        })
        .catch((err) => {
          console.log(err, 'err_getPaperInfo');
          this.loadingState = false;
        });
    },
    /**
     * 保存问卷
     */
    submeAnswer() {
      let flag = true;
      let flagTitle = true;
      let flagOptions = true;
      this.$refs.addAnswerTabs.validate((valid, msg) => {
        console.log(msg, '错误消息');
        if (!valid) {
          if (msg.title) {
            this.$message.error(this.$t('addOrEdit.请输入题目'));
          } else if (msg.thirdPartyPaperUri) {
            this.$message.error(this.$t('addOrEdit.请输入URL或检查URL格式'));
          }
          flag = false;
          this.thirdPaper = false;
          return;
        }
      });
      if (!flag) {
        this.thirdPaper = false;
        return;
      }
      let questions = [];
      console.log(this.answerList, 'answerList');
      if (this.ruleForm.paperType == '0') {
        this.answerList.forEach((item, index) => {
          if (item.title === '') {
            this.$message.error(this.$t('addOrEdit.请输入题干'));
            flagTitle = false;
            return;
          }
          if (item.scaleType == -1) {
            item.options.forEach((option) => {
              if (!option.completion) {
                option.required = false;
              }
              if (option.item === '') {
                flagOptions = false;
              }
            });
          } else {
            item.options.forEach((option) => {
              if (option.item === '') {
                flagOptions = false;
              }
            });
            item.options.forEach((option) => {
              delete option.showInput;
              delete option.error;
            });
          }
          item.options.sort(function (a, b) {
            return a.number.charCodeAt() - b.number.charCodeAt();
          });
          let list = {
            num: index + 1,
            title: item.title,
            type: item.choose,
            options: item.options,
            scaleType: item.scaleType,
            force: item.force
          };
          questions.push(list);
        });
        if (flagTitle && !flagOptions) {
          this.$message.error(this.$t('addOrEdit.请输入选项'));
        }
        if (!flagTitle || !flagOptions) {
          this.thirdPaper = false;
          return;
        }
      }
      console.log(questions, 'questions');
      this.addOrEditQusetionnaireFunc(questions);
    },
    /**
     * 发布第三方问卷
     */
    submeAnswerThree() {
      console.log(this.thirdPaper, 'this.thirdPaper');
      if (!this.thirdPaper) {
        this.thirdPaper = true;
        if (!this.publishLoading) {
          this.submeAnswer();
        }
      }
    },
    addOrEditQusetionnaireFunc(questions) {
      let params = {
        questions,
        title: this.ruleForm.title,
        thirdPartyPaperUri: this.ruleForm.thirdPartyPaperUri,
        paperType: this.ruleForm.paperType
      };
      if (this.edit) {
        params.id = this.paperId;
      }
      console.log(params, 'params');
      this.saveLoading = true;
      if (this.thirdPaper) {
        this.addThird(params);
      } else {
        this.addNormal(params);
      }
    },
    addNormal(params) {
      this.publishLoading = true;
      const newParams = { forceAnswer: this.forceAnswer, agreementEnable: this.agreementEnable }; //新增强制回答\隐私协议
      addOrEditQusetionnaire({ ...params, ...newParams }, this.$store.getters.liveToken)
        .then((res) => {
          //this.loadingState = false;
          this.successAdd(res);
        })
        .catch(() => {
          this.loadingState = false;
          this.saveLoading = false;
          this.publishLoading = false;
        });
    },
    addThird(params) {
      const newParams = { forceAnswer: this.forceAnswer, agreementEnable: this.agreementEnable }; //新增强制回答、隐私协议
      quickPublishing({ ...params, ...newParams }, this.$store.getters.liveToken)
        .then((res) => {
          this.saveLoading = false;
          this.successAddThird(res);
        })
        .catch(() => {
          this.loadingState = false;
          this.saveLoading = false;
        });
      this.thirdPaper = false;
    },
    successAddThird(res) {
      this.saveLoading = false;
      if (res.code === 200) {
        this.$message({
          message: this.$t('addOrEdit.问卷保存并发布成功'),
          type: 'success'
        });
        this.$emit('toPublish', res.data.confPaperId);
      } else {
        // if(res.code == 9006){
        //   this.$message.warning("该问卷已被其他人删除");
        // }else{
        this.$message.warning(res.msg);
        // }
        this.clearForm();
        this.$emit('refreshList', true);
      }
      this.publishLoading = false;
    },
    successAdd(res) {
      this.saveLoading = false;
      if (res.code === 200) {
        this.$message({
          message: this.$t('addOrEdit.问卷保存成功'),
          type: 'success'
        });
        if (this.edit) {
          this.$emit('toPublish');
        } else {
          this.clearForm();
          this.$emit('refreshList', true);
        }
      } else {
        if (res.code == 9006) {
          this.$message.warning(this.$t('addOrEdit.该问卷已被其他人删除'));
        } else {
          this.$message.warning(res.msg);
        }
        this.clearForm();
        this.$emit('refreshList', true);
      }
    },
    clearForm() {
      this.thirdPaper = false;
      this.answerList = [
        {
          id: 1,
          value: 1,
          up: false,
          down: false,
          choose: 0,
          title: '',
          options: [
            {
              number: 'A',
              item: '',
              error: '',
              completion: false,
              required: false
            },
            {
              number: 'B',
              item: '',
              error: '',
              completion: false,
              required: false
            }
          ],
          scaleType: -1,
          force: false
        }
      ];
      this.ruleForm.title = '';
      this.ruleForm.thirdPartyPaperUri = '';
      this.forceAnswer = false; //问卷添加成功后，将强制更新变为默认false
      this.agreementEnable = false; //问卷添加成功后，将隐私协议变为默认false
      this.$forceUpdate();
    },
    addMoreanswer() {
      let item = {
        up: false,
        down: false,
        choose: 0,
        tilte: '',
        options: [
          {
            number: 'A',
            item: '',
            completion: false,
            required: false
          },
          {
            number: 'B',
            item: '',
            completion: false,
            required: false
          }
        ],
        id: this.answerList.length + 1,
        value: this.answerList.length + 1,
        force: false
      };
      if (item.value === 1) {
        item.up = false;
        item.down = true;
      } else {
        item.up = true;
        item.down = true;
      }
      this.answerList.push(item);
      console.log(this.answerList, '添加新的answerList');
      this.updateAnswerList();
    },
    updateAnswerList() {
      let answerLen = this.answerList.length;
      this.answerList.forEach((item, index) => {
        if (index === answerLen - 1) {
          item.down = false;
        } else {
          item.down = true;
        }
        item.value = index + 1;
        item.id = index + 1;
      });
      console.log(this.answerList, '删除后answerList');
    },
    addMoreList(i) {
      if (this.answerList[i].moreAnswer.length > 20) return;
      console.log(this.answerList[i].moreAnswer);
      this.answerList[i].moreAnswer.push({
        label: ''
      });
      console.log(this.answerList[i].moreAnswer.length);
      this.$forceUpdate();
    },
    removeList(index) {
      this.answerList.splice(index, 1);
      this.updateAnswerList();
      this.showDelContent = false;
      this.showDelId = 0;
    },
    downList(index) {
      let arr = this.answerList;
      let nexIndex = arr.splice(index + 1, 1);
      arr.splice(index, 0, nexIndex[0]);
      console.log(arr);
      this.updateAnswerList();
    },
    upList(index) {
      let arr = this.answerList;
      let nexIndex = arr.splice(index, 1);
      arr.splice(index - 1, 0, nexIndex[0]);
      console.log(arr);

      this.updateAnswerList();
    },
    changeOptions(options) {
      console.log(options, 'changeOptions');
      this.answerList.forEach((item) => {
        console.log(item, 'item ');
        if (item.value === options.id) {
          item.choose = options.choose;
          if (item.choose === 2) {
            item.options = [];
            item.scaleType = -1;
          } else if (item.choose === 5) {
            item.options = [
              {
                number: 'A',
                item: this.$t('addOrEdit.很不满意'),
                score: 1,
                showInput: false
              },
              {
                number: 'B',
                item: this.$t('addOrEdit.很满意'),
                score: 2,
                showInput: false
              }
            ];
            item.scaleType = 0;
          } else {
            item.options = [
              {
                number: 'A',
                item: '',
                completion: false,
                required: false
              },
              {
                number: 'B',
                item: '',
                completion: false,
                required: false
              }
            ];
            item.scaleType = -1;
          }
        }
      });
      console.log('修改后的', this.answerList);
    },
    // changeNumber(options){
    //   console.log(options, "options");
    //   console.log("answerList", this.answerList);
    //   this.answerList.forEach((item) => {
    //     if (item.value === options.id) {
    //       item.options;
    //     }
    //   });
    // },
    titleChage(options) {
      this.answerList.forEach((item) => {
        if (item.value === options.id) {
          item.title = options.title;
        }
      });
      console.log(this.answerList, '答题列表');
    },
    forceChange(options) {
      this.answerList.forEach((item) => {
        if (item.value === options.id) {
          item.force = options.force;
        }
      });
    },
    updateSerial(options) {
      console.log(options, 'options');
      this.answerList.forEach((item) => {
        if (item.value === options.id) {
          item.options = options.levelItems;
        }
      });
      console.log(this.answerList, '答题列表');
    }
  }
};
</script>
<style scoped lang="scss">
.tips-title {
  color: #fff;
  font-size: 12px;
  margin-left: 12px;
}

.forceAnswer-divider {
  margin-top: 12px;
}

::v-deep .el-radio {
  color: $white-color;
}

.rightContent {
  height: 480px;
  width: 99%;
  background: $back-answer-color;
  padding: 20px 0 20px 0;
}
.questionnaire-new {
  margin-left: 20px;
}
.inputLong {
  width: 360px;
  margin-left: 8px;
  font-size: 12px;
}
.item-content {
  display: flex;
  padding-left: 67px;
  &-item {
    margin-right: 20px;
  }
}

.inputLong ::v-deep .el-input__inner {
  padding: 0 57px 0 15px;
  border-color: #525366;
}

.right-con {
  height: 430px;
  overflow-anchor: none;
}

.addInputLongItem ::v-deep .el-input__inner {
  padding: 0 57px 0 15px;
  border-color: #525366;
}

.left-nav ::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}

.right-con ::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}

.answerTabs ::v-deep .is-left {
  font-size: 12px;
}

.bottom-link {
  width: 140px;
  position: absolute;
  bottom: 16px;
  background-color: #f1f1f1;
  text-align: center;
  font-size: 12px;
}

.answerDialog ::v-deep .el-dialog .el-dialog__body {
  padding: 0px;
  height: 420px;
}

.answerDialog ::v-deep .el-dialog__header {
  background: #f1f1f1;
}

.answerDialog ::v-deep .el-dialog__body .el-tabs--left .el-tabs__header.is-left {
  width: 140px;
  height: 420px;
  background: #f1f1f1;
}

.answerDialog ::v-deep .el-dialog__body .el-tabs--left.el-tabs--card .el-tabs__item.is-left {
  height: 48px;
  line-height: 48px;
  text-align: center;
}

.answerDialog
  ::v-deep
  .el-dialog__body
  .el-tabs--left.el-tabs--card
  .el-tabs__item.is-left.is-active {
  border: 0px;
  background: #ffffff;
}

.answerDialog ::v-deep .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll .el-tabs__nav {
  border: 0px;
}

.addAnswerFrom ::v-deep .el-form-item__label {
  font-size: 12px;
  width: 60px;
}

.addAnswerFrom ::v-deep .el-form-item__content {
  line-height: 0px;
}

.addAnswerFrom {
  padding-right: 26px;
  ::v-deep .el-form-item {
    display: flex;
  }
}

.addInputLong {
  width: 86%;
  text-align: center;
}

.addMoreanswer .input-title-sm {
  width: 80px;
}

.link-blue {
  color: $bule-color;
  text-decoration: none;
  display: inline-block;
  height: 28px;
  line-height: 28px;
  padding: 0 15px;
  border-radius: 8px;
  margin-right: 15px;
  border: 1px solid $bule-color;
}
.link-download {
  color: $bule-color;
  text-decoration: none;
  font-size: 12px;
  &:hover {
    text-decoration: underline;
  }
}
[data-theme='Orange'] .link-download {
  color: #f89b33;
}

.save-blue {
  background-color: #3986ee;
  color: $white-color !important;
  float: right;
  height: 30px;
}

.publish-blue {
  float: right;
}

.addMoreanswer {
  background: #3c3f5c !important;
  color: $white-color !important;
  width: 144px;
  height: 36px;
  line-height: 36px;
  border: 0 none;
  border-radius: 273px;
  &:hover {
    background: #3986ee !important;
  }
}
[data-theme='Orange'] .addMoreanswer {
  background: #f1f1f1 !important;
  color: #606266 !important;
  &:hover {
    background: #f89b33 !important;
    color: #fff !important;
  }
}

.bottom-bar {
  padding-top: 20px;
  margin-left: 20px;
}

.upload-demo {
  display: inline-block;
}

.more-answer {
  padding: 10px;
}

::v-deep .el-select-dropdown {
  background: $back-answer-color;
}

.answers {
  position: relative;
  margin-bottom: 10px;
}

.icon {
  display: inline-block;
  height: 18px;
  width: 14px;
  vertical-align: middle;
  background-repeat: no-repeat;
  margin-left: 10px;
  color: $white-color;
  position: absolute;
  right: 0;
}

.icon-clear {
  // background: url(../../../svg/del-input.svg);
  background: rgba(228, 67, 40, 0.1);
  width: 86px;
  height: 32px;
  border-radius: 4px 0px 8px 0px;
  color: #e44328;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  cursor: pointer;
  bottom: 0;
  &:hover,
  &:active {
    background: #e44328;
    color: $white-color;
    .icon-del {
      background: url(../../../svg/icon-del-white.svg);
    }
  }
}
.icon-del {
  background: url(../../../svg/icon-del-red.svg);
  width: 11px;
  height: 11px;
  margin-right: 3px;
}

.icon-move-up {
  background: url(../../../svg/icon/icon-move-down.svg);
  right: 22px;
}

.icon-move-down {
  background: url(../../../svg/icon/icon-move-up.svg);
  right: 48px;
}

.add-control {
  text-align: left;
}

.paper-type {
  margin-bottom: 5px;
  ::v-deep .el-form-item__content {
    display: flex;
    height: 40px;
    align-items: center;
    padding-left: 12px;
  }
}
.paper-title {
  margin-bottom: 10px;
}
::v-deep .el-form-item__error {
  left: 8px;
}
.forceAnswer {
  margin-bottom: 10px;
}

.delContent {
  width: 211px;
  background: #35385e;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
  position: absolute;
  right: 0;
  bottom: 35px;
  z-index: 1000;
  padding: 20px 0;
  color: rgba(255, 255, 255, 0.65);
  font-size: 12px;

  a {
    text-decoration: none;
  }

  &-cancel {
    color: rgba(255, 255, 255, 0.65);
    margin-right: 20px;
  }

  &-sure {
    width: 44px;
    height: 22px;
    line-height: 22px;
    background: #3986ee;
    border-radius: 4px;
    display: inline-block;
    color: #fff;
  }

  &-control {
    margin-top: 20px;
  }
}

.error-icon-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.error-icon {
  width: 12px;
  height: 12px;
  background: #ea494b;
  border-radius: 12px;
  display: flex;
  color: #35385e;
  margin-right: 2px;
  font-size: 10px;
  align-items: center;
  justify-content: center;
}
[data-theme='Orange'] .error-icon {
  color: #fff;
}

.questionnaire-new .forceAnswer ::v-deep .el-form-item__content {
  text-align: left;
  line-height: 35px;
}
/* 滚动条的宽度 */
::v-deep .el-textarea__inner::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* 滚动条轨道的样式 */
::v-deep .el-textarea__inner::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
  width: 4px;
  background: transparent;
}

/* 滚动条的样式 */
::v-deep .el-textarea__inner::-webkit-scrollbar-thumb {
  width: 5px;
  margin: auto;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
  background: transparent;
  border-radius: 10px;
}
// [data-theme='Orange'] .answerList ::v-deep .el-textarea__inner,
// .answerList ::v-deep .el-input__inner,
// .answerList ::v-deep .el-checkbox__inner {
//   background: #fff !important;
// }
</style>
<style lang="scss">
.el-divider {
  background-color: $divider-color;
}

.el-radio__inner {
  border: 1px solid #acb2bf;
  background: none;
}

.el-radio__input.is-checked .el-radio__inner {
  background: none;
  border-color: #3986ee;
}

.el-radio__inner::after {
  width: 8px;
  height: 8px;
  background: #3986ee;
}
</style>
